<template>
  <v-sheet class="document-list">
    <base-list
      :userType="userType"
      :listItems="badges"
      :showAdd="false"
      :showDelete="showDelete"
      backgroundColor="#f2eae2"
    />
    <badge-upload v-if="showDelete" />
  </v-sheet>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import BadgeUpload from "@/containers/badges/BadgeUpload"
import { BadgesAPI } from "@/lib/api"
import eventMixin from "@/mixins/eventMixin"
import BaseList from "@/components/BaseList"
import User from "@/lib/user"

export default {
  mixins: [eventMixin, titleMixin],
  components: {
    BadgeUpload,
    BaseList
  },
  data: function() {
    return {
      title: "Badge Library",
      badges: [],
      userType: User.getUserType(),
      showDelete: !User.isMember(),
      showUpload: !User.isMember()
    }
  },
  methods: {
    getBadges: function() {
      BadgesAPI.list().then(response => {
        this.badges = response
      })
    },
    setLink(el) {
      return {}
    }
  },
  created() {
    this.addListener("badge:create", model => {
      this.getBadges()
    })

    this.addListener("list:removeItem", itemId => {
      BadgesAPI.delete(itemId).then(() => {
        this.getBadges()
      })
    })
    this.getBadges()
  }
}
</script>

<style lang="css" scoped>
.document-list {
  max-width: 800px;
}
</style>
